/**
 * Client-side Sentry for JavaScript error tracking.
 * Initialized only when meta tags sentry-dsn and sentry-env are present (production/staging).
 * Stimulus controller errors are reported via application.handleError in controllers/application.js.
 */
import * as Sentry from "@sentry/browser"

const dsn = document.querySelector('meta[name="sentry-dsn"]')?.getAttribute("content")
const env = document.querySelector('meta[name="sentry-env"]')?.getAttribute("content")

if (dsn && env) {
  Sentry.init({
    dsn,
    environment: env,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    // Sample a fraction of performance traces to limit overhead and Sentry usage (1.0 = 100%)
    tracesSampleRate: env === "production" ? 0.1 : 0.5,
    // Benign errors emitted when the user navigates away / closes the tab while a
    // fetch is in-flight (Turbo Drive visits cancel pending requests, our own
    // controllers use AbortController). They are not actionable, so we drop them.
    ignoreErrors: [
      "AbortError",
      "The user aborted a request",
      "The operation was aborted",
    ],
    beforeSend(event, hint) {
      const error = hint?.originalException
      if (error && (error.name === "AbortError" || error.code === 20)) {
        return null
      }
      return event
    },
  })
  window.Sentry = Sentry
}
